import React, { useState, useEffect } from "react";
import { Row, Col } from "react-bootstrap";

import Button from "react-bootstrap/Button";


import FldCloseIcon from "../images/round-close-icon.svg";

import ValidationAlertIcon from "../images/validation-alert-icon.svg";
const SignUpLogin = () => {
 


  return (
    <div className="mobile-wrapper bg-grey-variant">

      <div className="mobile-wrapper-inner bg-grey-variant">
      
      <div className="signup-login-header">
        <a className="back-link" href="#">Back</a>
          <h2>Sign up or log-in</h2>
          <p className="mb-3">Confirm your email to continue. </p>
        </div>

        <div className="mob-fld-wrap position-relative mb-4">
          <label className="form-label">Email</label>
          <input type="email" className="form-control mob-pr-44 validation-alert-brdr" name="email-fld" placeholder="Email" />
          <Button variant="" className="fld-close-btn"><img src={FldCloseIcon} /></Button>
          <div className="validation-alert"><img src={ValidationAlertIcon} /></div>
          <div className="mob-error-msg">Invalid email address</div>
        </div>

        <Button variant="primary" className="btn w-100 mb-4" disabled>Continue</Button>

        <div className="signup-btm-wrap">
          <p>By signing up, you agree to <a href="#">Terms</a> and <a href="#">Privacy Policy.</a></p>
        </div>

        

        
        
        
        
        
                       
        
      </div>
    </div>
  );
};

export default SignUpLogin;
